var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1631003550669,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12943,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.331676 421.998703H509.343135v188.360648H789.033514a296.351135 296.351135 0 0 1-58.395676 96.145298c-16.217946 18.265946-34.317838 34.649946-54.576433 48.432432l156.478271 125.536865a491.077189 491.077189 0 0 0 161.736648-458.475243",
    fill: "#8a8a8a",
    "p-id": 12944
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M676.061405 754.992432a294.469189 294.469189 0 0 1-166.773621 51.698163c-88.174703 0-166.496865-39.133405-220.962595-100.185946a295.244108 295.244108 0 0 1-57.565405-96.311352l-126.865298 96.311352-33.653621 25.627675a492.239568 492.239568 0 0 0 439.046919 269.89319c31.052108 0 61.329297-3.210378 90.776216-8.690163a490.246919 490.246919 0 0 0 232.531027-112.806054l-156.533622-125.536865z",
    fill: "#8a8a8a",
    "p-id": 12945
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995676 509.343135c0-36.531892 7.527784-71.126486 19.594378-103.507027L72.122811 282.845405A489.693405 489.693405 0 0 0 16.605405 509.343135c0 46.716541 6.97427 91.772541 19.096217 134.614487 6.088649 21.476324 13.450378 42.399135 22.251243 62.547027 3.819243 8.745514 8.025946 17.158919 12.288 25.627675l33.708973-25.572324 126.754594-96.311351a292.697946 292.697946 0 0 1-10.627459-34.483892 295.576216 295.576216 0 0 1-8.081297-66.421622",
    fill: "#8a8a8a",
    "p-id": 12946
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600.064 25.129514A495.782054 495.782054 0 0 0 509.287784 16.605405C332.827676 16.605405 178.452757 109.595676 91.440432 249.081081c-5.535135 8.856216-11.180973 17.712432-16.162594 26.956108-1.107027 2.158703-2.103351 4.428108-3.210379 6.642162l159.467244 123.156757c7.251027-19.428324 16.162595-37.971027 27.122162-55.240649a298.067027 298.067027 0 0 1 68.303567-74.55827c50.480432-39.520865 113.248865-64.096865 182.327352-64.096865 31.827027 0 61.993514 5.977946 90.776216 15.221622 33.764324 10.904216 64.761081 27.45427 91.993946 48.875243 4.428108 3.431784 9.40973 6.199351 13.50573 9.907892l9.963243-9.963243 128.19373-128.525838A490.855784 490.855784 0 0 0 600.064 25.074162",
    fill: "#8a8a8a",
    "p-id": 12947
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7f03d7d5fd17e9ec535251edf8b36642.svg";
export { ForwardRef as ReactComponent };